<template>
  <div class="container-fluid">
    <div class="block-header">
      <div class="row clearfix breadcrumb-margin-lg">
        <div class="col-7 col-lg-6 col-md-6 col-sm-7 mt-1">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="#">Master</a></li>
              <li class="breadcrumb-item active" aria-current="page">Helper Master</li>
            </ol>
          </nav>
        </div>
        <div class="col-5 col-lg-6 col-md-6 col-sm-5">
          <router-link
            :to="'/admin/master/helper_master/add'"
            class="btn float-right btn-info"
            title="Add Helper Master"
            ><i class="fa fa-plus pr-1"></i>Add Helper</router-link
          >
        </div>
      </div>
    </div>

    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card body-margin">
          <!--  <div class="header">
            <ul class="header-dropdown dropdown">
              <li>
                  <a href="javascript:void(0);" class="full-screen"
                    ><i class="icon-frame"></i
                  ></a>
                </li> 
            </ul>
          </div>-->

          <div class="body">
            <v-app>
              <div>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    outlined
                    dense
                    hide-details
                    class="search-field br-radius"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-card class="mx-auto m-fix" tile>
                    <!-- <v-card-title>Helper Master Details</v-card-title> -->
                    <!-- <v-data-table
                      :headers="headers"
                      :items="helper_masters"
                      loading-text="Loading... Please wait"
                      :search="search"
                      class="elevation-0"
                      :loading="loading"
                      hide-default-footer
                      disable-pagination
                    >
                      <template v-slot:[`item.index`]="{ item }">
                        <span>{{
                          helper_masters.indexOf(item) + 1 + (currentPage - 1) * pageSize
                        }}</span>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <div>
                          <v-menu
                            offset-y
                            attach
                            rounded="b-xl"
                            origin="center center"
                            transition="scale-transition"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn color="primary" dark v-bind="attrs" v-on="on">
                                Action
                                <v-icon right dark> mdi-chevron-down </v-icon>
                              </v-btn>
                            </template>
                            <v-list-item-group color="primary">
                              <v-list dense>
                                <v-list-item
                                  v-for="(action, index) in actionmenu(item)"
                                  :key="index"
                                  @click="performAction(action, item.helper_master_id)"
                                >
                                  <v-list-item-icon>
                                    <v-icon v-text="action.icon"></v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title v-text="action.text"></v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-list-item-group>
                          </v-menu>
                        </div>
                      </template>
                    </v-data-table> -->

                    <ag-grid-vue
                      class="ag-theme-alpine"
                      style="width: 100%; height: auto"
                      :columnDefs="columnDefs"
                      :rowData="helper_masters"
                      :gridOptions="gridOptions"
                      :domLayout="'autoHeight'"
                      @grid-ready="onGridReady"
                    >
                    </ag-grid-vue>

                    <v-col cols="12" sm="12">
                      <v-row>
                        <v-col cols="4" sm="3">
                          <v-select
                            attach=""
                            v-model="pageSize"
                            :items="pageSizes"
                            :menu-props="{ bottom: true, offsetY: true }"
                            label="Items per Page"
                            @change="handlePageSizeChange"
                          ></v-select>
                        </v-col>

                        <v-col cols="12" sm="9">
                          <v-pagination
                            v-model="currentPage"
                            :length="lastPage"
                            @input="handlePageChange"
                            total-visible="10"
                          ></v-pagination>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-card>
                </v-col>
              </div>
            </v-app>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataService from '../../../dataservice';
import { AgGridVue } from 'ag-grid-vue';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
export default {
  components: {
    AgGridVue,
  },
  data() {
    return {
      loading: true,
      totalItems: 0,
      currentPage: 1,
      lastPage: 0,
      search: '',
      pageSize: 10,
      pageSizes: [10, 25, 50, 100],
      helper_masters: [],
      headers: [
        { text: 'Sr. No.', value: 'index' },
        // { text: "ID", value: "helper_master_id" },
        { text: 'Actions', value: 'actions', sortable: false },
        { text: 'Helper Type', value: 'helpertype_title' },
        { text: 'Helper Master', value: 'helper_master_title' },
        { text: 'Status', value: 'helper_master_isactive' },
      ],

      gridApi: null,

      columnDefs: [
        {
          headerName: 'Sr. No.',
          valueGetter: params => {
            return params.node.rowIndex + 1 + (this.currentPage - 1) * this.pageSize;
          },
          width: 120,
        },

        {
          headerName: 'Actions',
          field: 'actions',
          width: 260,
          cellRenderer: params => {
            const button = document.createElement('button');

            button.innerHTML = `Action <i class="fa fa-chevron-down"></i>`;
            button.classList.add('btn', 'btn-primary');

            button.addEventListener('click', e => {
              e.stopPropagation();

              const oldMenu = document.getElementById('action-menu');
              if (oldMenu) oldMenu.remove();

              const actions = this.actionmenu(params.data);

              const menu = document.createElement('div');
              menu.id = 'action-menu';

              menu.style.position = 'fixed';
              menu.style.background = '#fff';
              menu.style.borderRadius = '8px';
              menu.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
              menu.style.padding = '8px 0';
              menu.style.zIndex = '9999';
              menu.style.minWidth = '180px';

              actions.forEach(action => {
                const item = document.createElement('div');

                item.style.display = 'flex';
                item.style.alignItems = 'center';
                item.style.gap = '8px';
                item.style.padding = '8px 12px';
                item.style.cursor = 'pointer';

                const icon = document.createElement('i');
                icon.className = `mdi ${action.icon}`;

                const text = document.createElement('span');
                text.innerText = action.text;

                item.appendChild(icon);
                item.appendChild(text);

                item.addEventListener('click', e => {
                  e.stopPropagation();
                  menu.remove();

                  setTimeout(() => {
                    this.performAction(action, params.data.helper_master_id);
                  }, 50);
                });

                item.addEventListener('mouseover', () => {
                  item.style.background = '#f5f5f5';
                });

                item.addEventListener('mouseout', () => {
                  item.style.background = '#fff';
                });

                menu.appendChild(item);
              });

              document.body.appendChild(menu);

              const rect = button.getBoundingClientRect();
              menu.style.top = rect.bottom + 'px';
              menu.style.left = rect.left + 'px';

              setTimeout(() => {
                const handler = event => {
                  if (!menu.contains(event.target)) {
                    menu.remove();
                    document.removeEventListener('click', handler);
                  }
                };
                document.addEventListener('click', handler);
              });

              const scrollHandler = () => {
                const existing = document.getElementById('action-menu');
                if (existing) existing.remove();
                window.removeEventListener('scroll', scrollHandler);
              };
              window.addEventListener('scroll', scrollHandler);
            });

            return button;
          },
        },

        {
          headerName: 'Helper Type',
          field: 'helpertype_title',
          flex: 1,
        },

        {
          headerName: 'Helper Master',
          field: 'helper_master_title',
          flex: 1,
        },

        {
          headerName: 'Status',
          field: 'helper_master_isactive',
          width: 150,
        },
      ],

      gridOptions: {
        suppressRowClickSelection: true,
      },
    };
  },
  //this one will populate new data set when user changes current page.
  // watch: {
  //   currentPage() {
  //     this.readData();
  //   },
  // },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
    },

    handlePageChange(value) {
      this.currentPage = value;
      this.readData();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.readData();
    },
    actionmenu(item) {
      const actionmenu = [
        { text: 'Edit', icon: 'mdi-pencil' },
        {
          text: item.helper_master_isactive == 'N' ? 'Activate' : 'Deactivate',
          icon:
            item.helper_master_isactive == 'N'
              ? 'mdi-toggle-switch'
              : 'mdi-toggle-switch-off-outline',
        },
        { text: 'Delete', icon: 'mdi-delete' },
      ];

      return actionmenu;
    },
    performAction(action, id) {
      if (action.text == 'Edit') this.editHelperMaster(id);
      else if (action.text == 'Delete') this.DelHelperTypeMaster(id);
      else if (action.text == 'Activate' || action.text == 'Deactivate')
        this.ToggleHelperMasterActiveStatus(id);
    },
    readData() {
      this.loading = true;
      DataService.getHelperMaster(this.currentPage, this.pageSize)
        .then(response => {
          this.helper_masters = response.data.data;
          this.totalItems = response.data.total;
          this.loading = false;
          this.currentPage = response.data.current_page;
          this.lastPage = response.data.last_page;
        })
        .catch(e => {
          // console.log(e);
        });
    },
    editHelperMaster(id) {
      this.$router.push({
        path: `/admin/editMasterHelper/edit${id}`,
        params: { id: id },
      });
    },
    ToggleHelperMasterActiveStatus(id) {
      DataService.HelperMasterActiveStatusToggle(id).then(response => {
        this.s('Helper-Master', 'Status has been updated successfully.');
        this.refreshList();
      });
    },
    DelHelperTypeMaster(id) {
      DataService.deleteHelperMaster(id).then(response => {
        this.s('Record Deleted');
        this.refreshList();
      });
    },
    refreshList() {
      this.readData();
    },
  },

  mounted() {
    this.readData();
  },
};
</script>
<style scoped>
.body-margin {
  margin-top: -24px !important;
}
.search-field {
  margin-top: -48px !important;
}
.m-fix {
  margin-top: -14px;
}
</style>
<style>
.menu-item {
  padding: 8px 10px;
  cursor: pointer;
}

.menu-item:hover {
  background: #f5f5f5;
}
</style>
